import { Subject, Observable, share } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root'})
export class ScrollService {
    public scrolling$: Subject<any>;

    private animationFrameRequest: any;

    constructor() {
        this.scrolling$ = new Subject();
    }

    getScrollingNotifications(): Observable<any> {
        return this.scrolling$
          .pipe(
            share()
          );
    }

    scrolling() {
        this.scrolling$.next(null);
    }

    scrollTo(scrollTo: string | number, limit?: number) {
        this.scrolling$.next({ scrollTo, limit });
    }

    /**
     * Scroll to container position
     *
     * @param {*} window
     * @param {HTMLElement} element - scrolling container
     * @param {number} scrollTargetY target
     * @param {number} [speed]  time in pixels per second
     * @param {string} [easing] easing equation to use
     * @memberof ScrollService
     */
    scrollToY(window: any, element: HTMLElement, scrollTargetY: number, speed?: number, easing?: string) {

        this.animationFrameRequest = (() => {
            return window.requestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              ((callback) => {
                  window.setTimeout(callback, 1000 / 60);
              });
        })();

        // scrollTargetY: the target scrollY property of the element
        // speed: time in pixels per second
        // easing: easing equation to use

        const scrollY = element.scrollTop;
        let target = scrollTargetY || 0;
        let spd = speed || 800;
        let ease = easing || 'easeInOutSine';
        let currentTime = 0;
        let frameRequest = this.animationFrameRequest;
        let scrollTime = Math.abs(scrollY - scrollTargetY);
        let scrollTime2 = scrollTime / spd;
        let time = Math.max(0.1, Math.min(scrollTime2, 0.8));

        let easingEquations = {
            easeOutSine: (pos) => {
                return Math.sin(pos * (Math.PI / 2));
            },
            easeInOutSine: (pos) => {
                return (-0.5 * (Math.cos(Math.PI * pos) - 1));
            },
            easeInOutQuint: (pos) => {
                pos /= 0.5;
                if ((pos) < 1) {
                    return 0.5 * Math.pow(pos, 5);
                }
                return 0.5 * (Math.pow((pos - 2), 5) + 2);
            }
        };

        // add animation loop
        function tick() {
            currentTime += 1 / 60;

            let p = currentTime / time;
            let t = easingEquations[ease](p);

            if (p < 1) {
                frameRequest(tick);
                element.scrollTop = scrollY + ((scrollTargetY - scrollY) * t);
            } else {
                element.scrollTop = scrollTargetY;
            }
        }

        // call it once to get started
        tick();
    }
}
